var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-subheader',[_vm._v("Manage")]),_c('v-list-item',{attrs:{"link":"","to":'/manage/maps/'}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-office-building-marker-outline")])],1),_c('v-list-item-title',[_vm._v("Manage Maps")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }